import axios from "axios";
import Utility from "../../../shared/utility";
import { store } from "../../../state-management/state-mgmt";
export default {
  getInitalList(call, userId) {
    return this.getData(`rv/discrep_resolve_init?user_id=${userId}`, call);
  },
  postSearch(call, obj, showMessage) {
    return this.getData(`rv/discrep_resolve_search`, call, obj, showMessage);
  },
 
  getDiscrepancyDetails(call,line_id){
    return this.getData(`rv/discrep_resolve_load_detail?line_id=${line_id}`, call);
  },

  getResolutionDetails(call, obj, showMessage) {
    return this.getData(`rv/discrep_get_resolutions`, call, obj, showMessage);
  },
  postResolveUpdateAction(call, obj, showMessage) {
    return this.getData(`rv/discrep_resolve_update`, call, obj, showMessage);
  },
  postDiscrepancyLabel(call, obj, showMessage) {
    return this.getData(`rv/discrep_label`, call, obj, showMessage);
  },

  postOrderSearch(call, obj, showMessage) {
    return this.getData(`rv/discrep_resolve_order_search`, call, obj, showMessage);
  },
  getLineItems(call, obj, showMessage) {
    return this.getData(`rv/discrep_resolve_get_avail_lines`, call, obj, showMessage);
  },

  // Receiving Page

  getReceiveProject(call,userId,type){
    return this.getData(`rv/receiving_projects_get?UserId=${userId}&po_so=${type}`, call);
  },

  postValidateLPNStage(call,obj,showMessage){
    return this.getData("rv/receiving_stage_lpn_val",call,obj,showMessage)
  },
  getStagingLocationList(call, showMessage, projKey){
    const selectedProjKey = typeof projKey === "object" ? projKey?.proj_key || projKey?.project_id : projKey;
    const hasProjKey = selectedProjKey !== undefined && selectedProjKey !== null && selectedProjKey !== "";
    if (!hasProjKey) return [];
    return this.getData(`rv/staging_location?proj_key=${encodeURIComponent(selectedProjKey)}`, call, undefined, showMessage);
  },

  postSalesOrderSearch(call,obj,showMessage){
    return this.getData("rv/receiving_so_search",call,obj,showMessage)
  },
  postPurchaseOrderSearch(call,obj,showMessage){
    return this.getData("rv/receiving_po_search",call,obj,showMessage)
  },
  postSalesOrderAdvance(call,obj,showMessage){
    return this.getData("rv/receiving_so_adv_search",call,obj,showMessage)
  },
  postPurchaseOrderAdvance(call,obj,showMessage){
    return this.getData("rv/receiving_po_adv_search",call,obj,showMessage)
  },
  getStockroomList(call,userId,stockroomText,showMessage){
    return this.getData(`rv/receiving_warehouses_get?UserId=${userId}&SearchStr=${stockroomText}`, call,showMessage);
  },
  submitReceiveLineItem(call,obj,showMessage){
    return this.getData("rv/receiving_submit",call,obj,showMessage)
  },

  postPartCheck(call,obj,showMessage){
    return this.getData("rv/receiving_discrepancy_validate",call,obj,showMessage)
  },
  postDiscrepancySave(call,obj,showMessage){
    return this.getData("rv/receiving_discrepancy_insert",call,obj,showMessage)
  },
  onBlurDiscrepancy(call,obj,showMessage){
    return this.getData("rv/receiving_discrepancy_tag_validate",call,obj,showMessage)
  },

  postIdentifierValidation(call,obj,showMessage){
    return this.getData("rv/receiving_identifier_validate",call,obj,showMessage)
  },

  // US bank Flow
  getPartListData(call,userId,text,showMessage){
    return this.getData(`rv/receiving_part_search?UserId=${userId}&SearchStr=${text}`, call,showMessage);
  },
  getPartDetails(call,userId,text,showMessage){
    return this.getData(`rv/receiving_part_details?UserId=${userId}&part_key=${text}`, call,showMessage);
  },
  postUsBankValidate(call,obj,showMessage){
    return this.getData("rv/receiving_validate_serialno",call,obj,showMessage)
  },

  postUsBankExternalAssetInfo(call,obj,showMessage){
    return this.getData("ex/x_usb_scan_ntt",call,obj,showMessage)
  },

  postUpdateAsset(call,obj,showMessage){
    return this.getData("rv/receiving_update_asset_action",call,obj,showMessage)
  },

  postLineTypeList(call,obj,showMessage){
    return this.getData("rv/receiving_so_line_type",call,obj,showMessage)
  },
 
  postLinePartList(call,obj,showMessage){
    return this.getData("so/so_returnpart_search",call,obj,showMessage)
  },
  postLineWarehouseData(call,obj,showMessage){
    return this.getData("so/so_ppid_validate",call,obj,showMessage)
  },
  postLineItemAdd(call,obj,showMessage){
    return this.getData("rv/receiving_so_order_update",call,obj,showMessage)
  },
  getLineItemDetails(call,userId,lineId,showMessage){
    return this.getData(`rv/receiving_so_order_lineitem_details?UserId=${userId}&line_id=${lineId}`,call,showMessage)
  },
  postLineTypePOList(call,obj,showMessage){
    return this.getData("rv/receiving_po_line_types",call,obj,showMessage)
  },
  postLinePartPOList(call,obj,showMessage){
    return this.getData("po/po_receivepart_search",call,obj,showMessage)
  },
  postLineWarehousePOData(call,obj,showMessage){
    return this.getData("po/po_ppid_validate",call,obj,showMessage)
  },
  postLineItemPOAdd(call,obj,showMessage){
    return this.getData("rv/receiving_po_order_update",call,obj,showMessage)
  },
  postLineItemPODetails(call,obj,showMessage){
    return this.getData("rv/receiving_po_lineitem_details",call,obj,showMessage)
  },






  

//receiving details

  getRecevingSalesOrderDetails(call,userId,soKey,showMessage){
    return this.getData(`rv/receiving_so_header_get?UserId=${userId}&so_key=${soKey}`, call,showMessage);
  },

  getRecevingSalesOrderLineItems(call,obj,showMessage){
   return this.getData("rv/receiving_so_lineitems_get",call,obj,showMessage)
  },

  getRecevingPurchaseOrderDetails(call,userId,poKey,showMessage){
    return this.getData(`rv/receiving_po_header_get?UserId=${userId}&po_key=${poKey}`, call,showMessage);
  },

  getRecevingPurchaseOrderLineItems(call,obj,showMessage){
   return this.getData("rv/receiving_po_lineitems_get",call,obj,showMessage)
  },

  postChangeLpn(call,obj,showMessage){
    return this.getData("rv/receiving_lpn_change",call,obj,showMessage)
  },

  getReasonList(call,obj,showMessage){
    return this.getData("rv/receiving_get_reason",call,obj,showMessage)
  },
  getAddressData(call,obj,showMessage){
    return this.getData("rv/receiving_order_address",call,obj,showMessage)
  },
  postPartNum(call,obj,showMessage){
    return this.getData("rv/receiving_discrepancy_part_search",call,obj,showMessage)
  },

  postQuickVerify(call,obj,showMessage){
    return this.getData("rv/receiving_receipt_audit",call,obj,showMessage)
  },

  getDiscrepancyOrderDetails(call,obj,showMessage){
    return this.getData("rv/receiving_discrepancy_order",call,obj,showMessage)
  },
  postExceptionAPI(call,obj,showMessage){
    return this.getData("rv/receiving_receipt_exception",call,obj,showMessage)
  },

  postUnitInfoAction(call,obj,showMessage){
    return this.getData("rv/usb_receiving_submit",call,obj,showMessage)
  },

  postUSUnitInfoSubmit(call,obj,showMessage){
    return this.getData("rv/receiving_receive",call,obj,showMessage)
  },





  async getData(url, call, obj, showMessage) {
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    let res = {};
    if (call == "get") {
      res = await axios.get(url).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    } else {
      res = await axios.post(url, obj).catch(function (error) {
        if (error.response) {
          let Alert = {
            type: "error",
            isShow: true,
            message: error.response.data.message || error.response.message,
          };
          store.commit("ConfigModule/Alert", Alert);
          LoaderDialog.visible = false;
          store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        }
      });
    }
    if (res?.data?.body?.message != undefined || res?.data?.body?.message != null) {
      if (!res?.data?.body?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res?.data?.body?.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res.data.body.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: this.isJson(res?.data?.body?.message) ? JSON.parse(res?.data?.body?.message).Message : "" || res?.data?.body?.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        if (this.isJson(res?.data?.body?.message)) return JSON.parse(res?.data?.body?.message);
        else return `{"Status":200,"Message":"${res?.data?.body?.message}"}`;
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    } else if (res?.data?.body?.message == null) {
      if (res?.data?.body !== null) {
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return res?.data?.body;
      } else {
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse('{"message":"NA"}');
      }
    } else {
      if (!res?.data?.message) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(res?.data.message),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = res?.data?.message;
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return {};
      }
      try {
        if (showMessage) {
          let Alert = {
            type: "success",
            isShow: true,
            message: res.data.message,
          };
          store.commit("ConfigModule/Alert", Alert);
        }
        LoaderDialog.visible = false;
        store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        return JSON.parse(res?.data?.message);
      } catch (err) {
        let Alert = {
          type: "error",
          isShow: true,
          message: Utility.apiError(err),
        };
        store.commit("ConfigModule/Alert", Alert);
        this.errorMessage = err.message;
        return {};
      }
    }
  },
  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },
};
